// Options
const theme =  'light';
//const theme =  'dark';

// Init
let background_color = null;
let brand_text_class = null;
let variant_table = null; //primary,secondary,success,warning,danger,info,light,dark,link
let form_div_class = null;
let form_color_textbox = null;
let chart_color_font = null;
let chart_color_prices_decreasing = null;
let chart_color_prices_increasing = null;
let chart_color_mbuy = null;
let chart_color_msell = null;
let chart_color_volume = null;

if(theme==='light'){
    background_color = 'Snow';
    brand_text_class = 'text-light';
    variant_table="light";
    form_div_class = 'col-md-8 bg-light';
    form_color_textbox = '';
    chart_color_font = 'black';
    chart_color_prices_decreasing = "red";
    chart_color_prices_increasing = "green";
    chart_color_mbuy = "blue";
    chart_color_msell = "red";
    chart_color_volume = "rgb(158,202,225)";

}else if(theme==='dark'){
    background_color = '#222222';
    brand_text_class = 'text-success';
    variant_table="dark";
    form_div_class = 'col-md-8 bg-dark';
    form_color_textbox = 'lightgray';
    chart_color_font = 'white';
    chart_color_prices_decreasing = "red";
    chart_color_prices_increasing = "lightgreen";
    chart_color_mbuy = "aqua";
    chart_color_msell = "red";
    chart_color_volume = "rgb(158,202,225)";
}

export {background_color, brand_text_class, variant_table, form_div_class, form_color_textbox,
    chart_color_font, chart_color_prices_decreasing, chart_color_prices_increasing,
    chart_color_mbuy, chart_color_msell, chart_color_volume};
